import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getUserReviews, updateReviewHomepageStatus, deleteUserReview } from '../api/userReviews';

export const useUserReviews = () => {
    return useQuery({
        queryKey: ['user-reviews'],
        queryFn: () => getUserReviews(),
    });
}

export const useUpdateReviewHomepageStatus = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationKey: ['update-review-homepage-status'],
        mutationFn: ({ reviewId, showHomePage }) => updateReviewHomepageStatus(reviewId, showHomePage),
        onSuccess: () => {
            queryClient.invalidateQueries(['user-reviews']);
        },
    });
}

export const useDeleteUserReview = () => {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationKey: ['delete-user-review'],
        mutationFn: (reviewId) => deleteUserReview(reviewId),
        onSuccess: () => {
            queryClient.invalidateQueries(['user-reviews']);
        },
    });
}